module.exports = (__webpack_require__(11))(12);


//////////////////
// WEBPACK FOOTER
// delegated ../../node_modules/classnames/index.js from dll-reference vendor_lib
// module id = 12
// module chunks = 0